import { action, observable } from 'mobx';
import { ApplicationSettingEditForm } from 'application/application-setting/forms';
import {BaseEditViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import {ApplicationSettingService} from 'application/application-setting/services';

@applicationContext
class ApplicationSettingEditViewStore extends BaseEditViewStore {
    @observable accessor duplicateItems = null;
    @observable accessor name = '';
    constructor(rootStore, componentProps) {
        const id = componentProps && componentProps.modalParams && componentProps.modalParams.data.id;
        const service = new ApplicationSettingService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'application-setting',
            id: id,
            Form: ApplicationSettingEditForm,
            actions: () => {
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        this.name = response.data.name;
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    }
                }
            },
            FormClass: ApplicationSettingEditForm,
        });

        this.service = service;

        this.modalParams = componentProps.modalParams;
    }

    @action.bound
    async updateResource(resource) {
        this.form.setFieldsDisabled(true);
        try {
            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);
            this.modalParams.close();

            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch(error) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                error && error.data ? error.data :  `An error ocurred`
           );  
        }
    }

    @action.bound
    async saveResource(resource) {
        await this.service.create(resource);

        await this.onCreate();

        this.form.reset();
        resource.serialNumber = null;
        this.form.update(resource);
        this.duplicateItems = null;
        this.form.setFieldsDisabled(false);
        await setTimeout(() => this.notifySuccessCreate(), 10);
    }

}

export default ApplicationSettingEditViewStore;
